// extracted by mini-css-extract-plugin
var _1 = "NotificationItem-module__animatedBackground--k_fUV";
var _2 = "NotificationItem-module__avatarContainer--p9wUM";
var _3 = "NotificationItem-module__container--utLF_";
var _4 = "NotificationItem-module__dot--m5hia";
var _5 = "NotificationItem-module__dotContainer--IBh72";
var _6 = "NotificationItem-module__mainContent--Nb97K";
var _7 = "NotificationItem-module__notificationItem--_FweV";
var _8 = "NotificationItem-module__readControl--fKsoN";
var _9 = "NotificationItem-module__text--MU1i6";
var _a = "NotificationItem-module__timestamp--QmuNf";
var _b = "NotificationItem-module__unread--EnPH9";
export { _1 as "animatedBackground", _2 as "avatarContainer", _3 as "container", _4 as "dot", _5 as "dotContainer", _6 as "mainContent", _7 as "notificationItem", _8 as "readControl", _9 as "text", _a as "timestamp", _b as "unread" }
